import { render } from "./IotComponent.vue?vue&type=template&id=bea14916"
import script from "./IotComponent.vue?vue&type=script&lang=js"
export * from "./IotComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__